<template>
  <div>
    <slot name="trigger" :openModal="() => (showModal = true)">
      <button :class="buttonClasses" @click="showModal = true">Upload your Photos</button>
    </slot>

    <SrpModal v-model:isVisible="showModal" :isClosable="false">
      <template #header><h2 class="global-h2">Upload your Photos</h2></template>
      <template #content>
        <div style="margin: 10px 0">
          <UploadPhotosNonAdventure
            :customerId="customerId"
            :autoCloseAfterUpload="autoCloseAfterUpload"
            @imageAddedToGallery="$emit('imageAddedToGallery', $event)"
            @uploadComplete="doneUploading"
            @uploadProgressChange="isUploadingInProgress = $event"
          />
        </div>
      </template>
      <template #footer>
        <SrpButton @click="doneUploading" :isDisabled="isUploadingInProgress" fill="outlined">{{ isUploadingInProgress ? "Uploading..." : "Done" }}</SrpButton>
      </template>
    </SrpModal>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SrpModal from "@components/ui/SrpModal.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import UploadPhotosNonAdventure from "./UploadPhotosNonAdventure.vue";

export default defineComponent({
  name: "UploadPhotosNonAdventureModal",

  components: {
    SrpButton,
    SrpModal,
    UploadPhotosNonAdventure,
  },

  props: {
    customerId: { type: String, required: true },
    buttonClasses: { type: String, default: "ui small primary basic button" },
    autoCloseAfterUpload: { type: Boolean, default: true },
  },

  emits: ["imageAddedToGallery"],

  data() {
    return {
      showModal: false,
      isUploadingInProgress: false,
    };
  },

  methods: {
    doneUploading() {
      this.showModal = false;
    },
  },
});
</script>
